import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	starred: {
		id: 'directories.common.components.star-title-cell.starred',
		defaultMessage: 'Starred',
		description: 'Assistive label for the Starred sorting button table header',
	},
});
